import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
	initializeMfeResponse: {},
	apiError: false,
	clientId: "",
	cmp: {
		cmpValue: "",
		isFromGoogleShop: false,
	},
	editPackagePackageId: "",
	flow: "prospect",
	isEmptyByodFromDQFlow: false,
	bulkUploadResponse: {},
	isEditPackageFlow: false,
	isInitialAppLoadComplete: false,
	isNavigatedFrom5GToLTEPage: false,
	isNavigatedFromLTETo5GPage: false,
	isOrderQuoteFlow: false,
	portInMTN: false,
	loading: false,
	modals: {
		showNewCustomerModal: false,
	},
	notification: {
		closable: true,
		open: false,
		subtitle: "",
		title: "Not Provided",
		type: "warning",
	},
	sessionCartData: {},
	showStickyHeaderValues: true,
	ss7Domains: [],
	loadCheckoutWidget: false,
	retrieveLoader: false,
	navigatePath: "",
	selectedPaymentTab: "monthly",
	isInCompatibleContTerm: false,
	cartId: "",
	cpqCartVersionId: "",
};

const GlobalSlice = createSlice({
	name: "Application",
	initialState,
	reducers: {
		resetGlobalSlice: (state, action) => {
			return initialState;
		},
		setApiError: (state, action) => {
			state["apiError"] = action.payload;
		},
		setCmpValue: (state, action) => {
			state["cmp"]["cmpValue"] = action.payload;
		},
		setCombinePricingInfo: (state, action) => {
			state["combinePricing"] = action.payload;
		},
		setPortInMTN: (state, action) => {
			state["portInMTN"] = action.payload
		},
		setEditPackagePackageId: (state, action) => {
			state["editPackagePackageId"] = action.payload;
		},
		setCallAddOrUpdate: (state, action) => {
			state["CallAddOrUpdate"] = action.payload
		},
		setFlow: (state, action) => {
			state["flow"] = action.payload;
		},
		setIsEditPackageFlow: (state, action) => {
			state["isEditPackageFlow"] = action.payload;
		},
		setIsEmptyByodFromDQFlow: (state, action) => {
			state["isEmptyByodFromDQFlow"] = action.payload;
		},
		setIsFromGoogleShop: (state, action) => {
			state["cmp"]["isFromGoogleShop"] = action.payload;
		},
		setIsOrderQuoteFlow: (state, action) => {
			state["isOrderQuoteFlow"] = action.payload;
		},
		setLoading: (state, action) => {
			state["loading"] = action.payload;
		},
		setInitializeMfeResponse: (state, action) => {
			state["initializeMfeResponse"] = action.payload;
		},
		setMetaInfo: (state, action) => {
			state["metaInformation"] = action.payload;
		},
		setModalsState: (state, action) => {
			const { modalName, show } = action.payload;
			state["modals"][modalName] = show || false;
		},
		setNotification: (state, action) => {
			const { title, subtitle, closable, type, open } = action.payload;
			state["notification"] = {
				title: title || "NA",
				subtitle: subtitle || "",
				closable: closable || true,
				type: type || "warning",
				open: open || false,
			};
		},
		setSessionCartData: (state, action) => {
			state["sessionCartData"] = action.payload;
		},
		setShowStickyHeaderValues: (state, action) => {
			state["showStickyHeaderValues"] = action.payload;
		},
		setIsInitialAppLoadComplete: (state, action) => {
			state["isInitialAppLoadComplete"] = action.payload;
		},
		setss7Domains: (state, action) => {
			state["ss7Domains"] = action.payload;
		},
		setSaveCartSuccess: (state, action) => {
			state["saveCartSuccess"] = action.payload;
		},
		setCartId: (state, action) => {
			state["cartId"] = action.payload;
		},
		setCartVersionId: (state, action) => {
			state["cpqCartVersionId"] = action.payload;
		},
		setClientId: (state, action) => {
			state["clientId"] = action.payload;
		},
		setWidgetInputParams: (state, action) => {
			state["widgetInputParams"] = action.payload;
		},
		setManageServiceInfo: (state, action) => {
			state["manageServiceInfo"] = action.payload;
		},
		setIsNavigatedFrom5GToLTEPage: (state, action) => {
			state["isNavigatedFrom5GToLTEPage"] = action.payload;
			state["isNavigatedFromLTETo5GPage"] = false;
		},
		setIsNavigatedFromLTETo5GPage: (state, action) => {
			state["isNavigatedFromLTETo5GPage"] = action.payload;
			state["isNavigatedFrom5GToLTEPage"] = false;
		},
		setLoadShoppingCartWidget: (state, action) => {
			state["loadShoppingCartWidget"] = action.payload;
		},
		setLoadAddonPage: (state, action) => {
			state["loadAddonPage"] = action.payload;
		},
		setLoadBulkUpload: (state, action) => {
			state["loadBulkUpload"] = action.payload;
		},
		setLoadBulkOrder: (state, action) => {
			state["loadBulkOrder"] = action.payload;
		},
		setLoadCompleteOrder: (state, action) => {
			state["loadCompleteOrder"] = action.payload;
		},
		setLoadCheckoutWidget: (state, action) => {
			state["loadCheckoutWidget"] = action.payload;
		},
		setApiErrorNotification: (state, action) => {
			state["errorNotification"] = action.payload;
		},
		setLoadQualficationLanding: (state, action) => {
			state["loadQualficationLanding"] = action.payload;
		},
		setLoadQualficationSelection: (state, action) => {
			state["loadQualficationSelection"] = action.payload;
		},
		setLoadFWAQualifiedPlans: (state, action) => {
			state["loadFWAQualifiedPlans"] = action.payload;
		},
		setShowSimCompatible: (state, action) => {
			state["showSimCompatible"] = action.payload;
		},
		setBulkUploadResponse: (state, action) => {
			state["bulkUploadResponse"] = action.payload
		},
		setRetrieveLoader: (state, action) => {
			state["retrieveLoader"] = action.payload;
		},
		setBbloadError: (state, action) => {
			state["bbloadError"] = action.payload;
		},
		setContainerHeightBB: (state, action) => {
			state["containerHeightBB"] = action.payload;
		},
		setFeaturePageVisited: (state, action) => {
			state["featurePageVisted"] = action.payload;
		},
		setGWPlansID: (state, action) => {
			state["GWPlansID"] = action.payload;
		},
		setGWDeviceType: (state, action) => {
			state["GWDeviceType"] = action.payload;
		},
		setIsEditPlansFlow: (state, action) => {
			state["isEditPlansFlow"] = action.payload;
		},
		setIsEditPackageType: (state, action) => {
			state["isEditPackageType"] = action.payload;
		},
		setIsEditFeaturesFlow: (state, action) => {
			state["isEditFeaturesFlow"] = action.payload;
		},
		setEditFeaturesPackageId: (state, action) => {
			state["editFeaturesPackageId"] = action.payload;
		},
		setLoadMobilityProductDetails: (state, action) => {
			state["loadMobilityProductDetails"] = action.payload;
		},
		setSelectedGWProduct: (state, action) => {
			state["selectedGWProduct"] = action.payload;
		},
		setSelectedGWImageSS7: (state, action) => {
			state["selectedGWImageSS7"] = action.payload;
		},
		setLoadMobilityPlansPage: (state, action) => {
			state["loadMobilityPlansPage"] = action.payload;
		},
		setLoadMobilityFeaturesPage: (state, action) => {
			state["loadMobilityFeaturesPage"] = action.payload;
		},
		setLoadBussProductsPage: (state, action) => {
			state["loadBussProductsPage"] = action.payload;
		},
		setLoadBussPDPPage: (state, action) => {
			state["loadBussPDPPage"] = action.payload;
		},
		setLoadConfirmationWidget: (state, action) => {
			state["loadConfirmationWidget"] = action.payload;
		},
		setLoadFiosWidget: (state, action) => {
			state["loadFiosWidget"] = action.payload;
		},
		setCurrentFlow: (state, action) => {
			state["currentFlow"] = action.payload;
		},
		setNoThanksClicked: (state, action) => {
			state["IsNothanksClicked"] = action.payload;
		},
		setDomainForBuss: (state, action) => {
			state["domainForBuss"] = action.payload;
		},
		setLoadBackupPlans: (state, action) => {
			state["loadBackupPlans"] = action.payload;
		},
		setIsPlansFirstTwoYearsPP: (state, action) => {
			state["isPlansFirstTwoYearsPP"] = action.payload
		},
		setCategory: (state, action) => {
			state["category"] = action.payload
		},
		setEcpdId: (state, action) => {
			state["ecpdId"] = action.payload
		},
		setNavigatePath: (state, action) => {
			state["navigatePath"] = action.payload
		},
		setStorePreviousPaths: (state,action) => {
			state["storePreviousPaths"] = action.payload
		},
		setEntryPoint: (state, action) => {
			state["entryPoint"] = action.payload
		},
		selectedMiminumQuantity: (state, action) => {
			state["minimumQuantity"] = action.payload
		},
		setSelectedPaymentTab: (state, action) => {
			state["selectedPaymentTab"] = action.payload
		},
		setEditFeaturesPackageIds: (state, action) => {
			state["editFeaturesPackageIds"] = action.payload;
		},
		setIsAddMoreByodPackage: (state, action) => {
			state["isAddMoreByodPackage"] = action.payload;
		},
		setIsRetrieveCart: (state, action) => {
			state["isRetrieveCart"] = action.payload;
		},
		isNewCart: (state, action) => {
			state["newCart"] = action.payload
		},
		setIsPlanFirstFlowCompleted: (state, action) => {
			state["isPlanFirstFlowCompleted"] = action.payload
		},
		setModalFor4GPageOpened: (state, action) => {
			state["modalFor4GPageOpened"] = action.payload
		},

		setCurrentFlowForHPB: (state, action) => {
			state["currentFlowForHPB"] = action.payload
		},
		setCompletedPagesForHPB: (state, action) => {
			state["completedPagedForHPB"] = action.payload
		},
		setCurrentActiveStep: (state, action) => {
			state["currentActiveStep"] = action.payload
		},
		setSeletectedIndexForFWAHPB: (state, action) => {
			state["selectedIndexForFWAHPB"] = action.payload
		},
		setCategoryForHPB: (state, action) => {
			state["categoryForHPB"] = action.payload
		},
		setReinitiateFlow: (state, action) => {
			state["reinitiateFlow"] = action.payload
		},
		setIsStandAloneAccessoryFlow: (state, action) => {
			state["standAloneAccessoryFlow"] = action.payload
		},
		setGlobalAccessoryDetails: (state, action) => {
			state["userMTN"] = action.payload.userMTN ?? ""
			state["selectedPhoneId"] = action.payload.selectedPhoneId ?? ""
			state["zipCode"] = action.payload.zipCode ?? ""
		},
		setVBCEligible: (state, action) => {
			state["IsVBCEligible"] = action.payload;
		},
		setEditPackageGrpId: (state, action) => {
			state["editPackageGrpId"] = action.payload;
		},
		setTradeInValues: (state, action) => {
			state["tradeInValues"] = action.payload;
		},
		setTradeInState: (state, action) => {
			state["tradeInState"] = action.payload;
		},
		setNewMixedCartPlanFirstFlow: (state, action) => {
			state["newMixedCartPlanFirstFlow"] = action.payload;
		},
		setIsLTEOrCbandFlow: (state, action) => {
			state["isLTEOrCbandFlow"] = action.payload;
		},

		setIsWirelessToFwaFlow: (state, action) => {
			state["isWirelessToFwaFlow"] = action.payload
		},
		setJoBundleEnabled: (state, action) => {
			state["isJoBundleEnabled"] = action.payload;
		},
		setLoadMultiFWAFlow: (state, action) => {
			state["loadMultiFWAFlow"] = action.payload;
		},
		setStoreGridwallPDP: (state, action) => {
			state["storeGridwallPDP"] = action.payload
		},
		setAgentLocationCode: (state, action) => {
			state["agentLocationCode"] = action.payload
		},
		setAgentBCode: (state, action) => {
			state["agentBCode"] = action.payload
		},
		isFromMyLinkDealsPage: (state, action) => {
			state["fromMyLinkDealsPage"] = action.payload
		},
		isFromAgentLinkDealsPage: (state, action) => {
			state["fromAgentLinkDealsPage"] = action.payload
		},
		setAgentOutletId: (state, action) => {
			state["agentOutletId"] = action.payload
		},
		setTier2AgencyValue: (state, action) => {
			state["agentTier2Agency"] = action.payload
		},
		setAgentCompany: (state, action) => {
			state["agentCompany"] = action.payload
		},
		setDynamicPromoSelected: (state, action) => {
			state["dynamicPromoSelected"] = action.payload
		},
		setNotifyIncompatibleCT: (state, action) => {
			state["isInCompatibleContTerm"] = action.payload
		},
		setIsBISelectionComplete: (state, action) => {
			state["isBISelectionComplete"] = action.payload
		},
		setAddressValidation: (state, action) => {
      state["addressValidation"] = action.payload;
    },
	},
});

export const getFlow = (flow) => {
	try {
		if (FLOWS[flow]) return FLOWS[flow];
		else throw "Flow Not Found";
	} catch (ex) {
		return FLOWS.REGULAR;
	}
};

export const FLOWS = {
	dsp: "dsp",
	PLANFIRST: "PLANFIRST",
	REGULAR: "REGULAR",
	TYS: "TYS",
};

export const reducer = GlobalSlice.reducer;

export const showLoading = createAction("GlobalSlice/showLoading");
export const hideLoading = createAction("GlobalSlice/hideLoading");
export const showStickyHeaderValues = createAction(
	"GlobalSlice/showStickyHeaderValues"
);
export const hideStickyHeaderValues = createAction(
	"GlobalSlice/hideStickyHeaderValues"
);
export const changeApiError = createAction("GlobalSlice/changeApiError");
export const changeFlow = createAction("GlobalSlice/changeFlow");
export const resetFlow = createAction("GlobalSlice/resetFlow");
export const showNotification = createAction("GlobalSlice/showNotification");
export const hideNotification = createAction("GlobalSlice/hideNotification");
export const initializeMfe = createAction(
	"GlobalSlice/initializeMfe"
);
export const getMetaInformation = createAction(
	"GlobalSlice/getMetaInformation"
);
export const getSessionCart = createAction("GlobalSlice/getSessionCart");
export const getGlobalPageLoadData = createAction(
	"GlobalSlice/getGlobalPageLoadData"
);
export const getCombinePricing = createAction("GlobalSlice/getCombinePricing");
export const postSaveCart = createAction("GlobalSlice/postSaveCart");
export const callAddressValidation = createAction("GlobalSlice/callAddressValidation");

export const {
	resetGlobalSlice,
	setApiError,
	setCmpValue,
	setCombinePricingInfo,
	setEditPackagePackageId,
	setCallAddOrUpdate,
	setApiErrorNotification,
	setFlow,
	setLoading,
	setIsEditPackageFlow,
	setIsEmptyByodFromDQFlow,
	setIsFromGoogleShop,
	setIsOrderQuoteFlow,
	setInitializeMfeResponse,
	setMetaInfo,
	setModalsState,
	setNotification,
	setSessionCartData,
	setShowStickyHeaderValues,
	setIsInitialAppLoadComplete,
	setss7Domains,
	setSaveCartSuccess,
	setCartId,
	setCartVersionId,
	setIsNavigatedFrom5GToLTEPage,
	setClientId,
	setIsNavigatedFromLTETo5GPage,
	setLoadShoppingCartWidget,
	setLoadCheckoutWidget,
	setShowSimCompatible,
	setWidgetInputParams,
	setManageServiceInfo,
	setRetrieveLoader,
	setBbloadError,
	setContainerHeightBB,
	setGWPlansID,
	setGWDeviceType,
	setIsEditPlansFlow,
	setIsEditPackageType,
	setIsEditFeaturesFlow,
	setEditFeaturesPackageId,
	setLoadMobilityProductDetails,
	setLoadMobilityPlansPage,
	setLoadMobilityFeaturesPage,
	setLoadBussPDPPage,
	setLoadBussProductsPage,
	setFeaturePageVisited,
	setSelectedGWProduct,
	setLoadConfirmationWidget,
	setLoadQualficationLanding,
	setLoadQualficationSelection,
	setLoadFWAQualifiedPlans,
	setCurrentFlow,
	setNoThanksClicked,
	setDomainForBuss,
	setLoadAddonPage,
	setLoadBulkUpload,
	setLoadBulkOrder,
	setLoadCompleteOrder,
	setSelectedGWImageSS7,
	setLoadFiosWidget,
	setLoadBackupPlans,
	setCategory,
	setIsPlansFirstTwoYearsPP,
	setNavigatePath,
	selectedMiminumQuantity,
	setSelectedPaymentTab,
	setEditFeaturesPackageIds,
	setIsAddMoreByodPackage,
	setIsRetrieveCart,
	isNewCart,
	setPortInMTN,
	setIsPlanFirstFlowCompleted,
	setModalFor4GPageOpened,
	setBulkUploadResponse,
	setCurrentFlowForHPB,
	setCompletedPagesForHPB,
	setCurrentActiveStep,
	setSeletectedIndexForFWAHPB,
	setCategoryForHPB,
	setReinitiateFlow,
	setIsStandAloneAccessoryFlow,
	setGlobalAccessoryDetails,
	setVBCEligible,
	setEditPackageGrpId,
	setTradeInValues,
	setTradeInState,
	setIsWirelessToFwaFlow,
	setIsLTEOrCbandFlow,
	setNewMixedCartPlanFirstFlow,
	setJoBundleEnabled,
	setEntryPoint,
	setLoadMultiFWAFlow,
	setStoreGridwallPDP,
	setAgentLocationCode,
	setAgentBCode,
	setAgentOutletId,
	setTier2AgencyValue,
	setAgentCompany,
	setDynamicPromoSelected,
	setNotifyIncompatibleCT,
	isFromMyLinkDealsPage,
	isFromAgentLinkDealsPage,
	setIsBISelectionComplete,
	setStorePreviousPaths,
	setAddressValidation
} = GlobalSlice.actions;
